<script setup lang="ts">
    import { useRouter } from 'vue-router';
    import { Permissions } from '@shared/Root/Permissions';

    export interface SidebarMenuItem {
        routeNames: string[];
        label: string;
        requireScope?: { Feature: string; Permission: Permissions };
        feature?: string;
    }

    export interface SidebarMenuGroup {
        heading: string;
        items: SidebarMenuItem[];
    }

    defineProps<{
        groups: SidebarMenuGroup[];
    }>();

    const router = useRouter();

    const isCurrent = (routeNames: string[]) => {
        const currentPathObject = router.currentRoute.value;
        return routeNames.includes(currentPathObject.name?.toString() || '');
    };
</script>

<template>
    <ul class="tabs list-unstyled display-row" role="tablist">
        <li v-for="group in groups" :key="group.heading">
            <h4 class="tabs-heading">{{ group.heading }}</h4>

            <ul class="tabs list-unstyled display-row">
                <li
                    v-for="item in group.items"
                    :key="item.routeNames[0]"
                    v-require-scope="item.requireScope"
                    v-feature="item.feature"
                    :class="{ active: isCurrent(item.routeNames) }">
                    <router-link :to="{ name: item.routeNames[0] }">
                        {{ item.label }}
                    </router-link>
                </li>
            </ul>
        </li>
    </ul>
</template>
